/*

1 - Saida para compra
2 - Recebimento
3 - Pré Controle de Qualidade
4 - Desembalagem
5 - Inicio/ Personalização
6 - Término/ Personalização
7 - Finalização
8 - Pedido Despacho Em
11 - aprova piloto

*/

export const PERMISSION_USER = {
  0: { PERMISSION: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
  14: { PERMISSION: [9] },
  19: { PERMISSION: [1, 2, 3, 4, 5, 6, 7, 8, 10, 11] },
  21: { PERMISSION: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
  22: { PERMISSION: [1, 3, 4, 5, 6, 7, 8, 10, 11] },
  30: { PERMISSION: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
  45: { PERMISSION: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
  48: { PERMISSION: [7, 3, 6, 4] },
  50: { PERMISSION: [3, 4] },
  51: { PERMISSION: [3, 4] },
  52: { PERMISSION: [5, 6] },
  53: { PERMISSION: [5, 6] },
  54: { PERMISSION: [5, 6] },
  55: { PERMISSION: [5, 6] },
  75: { PERMISSION: [5, 6] },
  90: { PERMISSION: [5, 6] },
  91: { PERMISSION: [5, 6] },
  76: { PERMISSION: [5, 6] },
  77: { PERMISSION: [5, 6] },
  56: { PERMISSION: [3, 4, 5, 6] },
  60: { PERMISSION: [1, 3, 4, 5, 6, 7, 8, 10, 11] },
  72: { PERMISSION: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
  82: { PERMISSION: [3, 4, 7] },
  83: { PERMISSION: [1, 2, 3, 4, 7, 8, 9, 10] }, //alineP
  121: { PERMISSION: [1, 2, 3, 4, 7, 8, 9, 10] },
  87: { PERMISSION: [1, 2, 3, 4, 7, 8, 9, 10] }, //alineJ
  85: { PERMISSION: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11] }, //aline p e alinej estavaigual esse
  103: { PERMISSION: [5, 6] },
  110: { PERMISSION: [3, 4] },
  116: { PERMISSION: [3, 4, 7, 6, 5] },
  114: { PERMISSION: [9] },
  115: { PERMISSION: [9] },
  126: { PERMISSION: [3, 4, 5, 6] }, // Vinicius - mesmas permissões do CODUSU 56
  127: { PERMISSION: [3, 4, 5, 6] }, // Helloiza - mesmas permissões do CODUSU 56
  128: { PERMISSION: [3, 4, 5, 6] }, // Wellington - mesmas permissões do CODUSU 56
}

//3 - inicio desembalgem
//4 - fim desembalagem - data_desembalagem
